import { TaxKey } from '#dictionary'
import ProfileService from '#profile/ProfileService'

import type { TimelineRecord } from '../timeline/TimelineRecord'
import type { TotalTaxesCalculationResult } from '../types'
import AnnualTaxes from './AnnualTaxes'
import { MedicareTax, SocialSecurityTax } from './taxes'
import AdditionalMedicareTax from './taxes/AdditionalMedicareTax'
import AlternativeMinimumTax from './taxes/AlternativeMinimumTax'
import FederalTax from './taxes/FederalTax'
import NetInvestmentIncomeTax from './taxes/NetInvestmentIncomeTax'
import RealEstateTax from './taxes/RealEstateTax'
import StateTax from './taxes/StateTax'
import type { ITaxCalculator } from './taxes/types'

// #dk: assuming tax name is unique
class Taxer {
  private taxCalculators: Record<
    Exclude<TaxKey, TaxKey.TaxStateProperty>,
    ITaxCalculator
  > = {} as Record<Exclude<TaxKey, TaxKey.TaxStateProperty>, ITaxCalculator>
  private realEstateTaxCalculator: RealEstateTax

  constructor(private readonly profile: ProfileService) {
    this.taxCalculators[TaxKey.TaxMedicare] = new MedicareTax(
      TaxKey.TaxMedicare
    )
    this.taxCalculators[TaxKey.TaxSocialSecurity] = new SocialSecurityTax(
      TaxKey.TaxSocialSecurity
    )
    this.taxCalculators[TaxKey.TaxMedicareSE] = new MedicareTax(
      TaxKey.TaxMedicareSE
    )
    this.taxCalculators[TaxKey.TaxSocialSecuritySE] = new SocialSecurityTax(
      TaxKey.TaxSocialSecuritySE
    )
    this.taxCalculators[TaxKey.TaxFederalIncome] = new FederalTax(
      TaxKey.TaxFederalIncome,
      this.profile.projectionEndYear
    )
    this.taxCalculators[TaxKey.TaxCapitalGains] = new FederalTax(
      TaxKey.TaxCapitalGains,
      this.profile.projectionEndYear
    )
    this.taxCalculators[TaxKey.TaxStateIncome] = new StateTax(
      this.profile.projectionEndYear
    )
    this.taxCalculators[TaxKey.TaxAdditionalMedicare] =
      new AdditionalMedicareTax()

    this.taxCalculators[TaxKey.TaxNetInvestmentIncome] =
      new NetInvestmentIncomeTax()

    this.taxCalculators[TaxKey.TaxAlternativeMinimum] =
      new AlternativeMinimumTax()

    this.realEstateTaxCalculator = new RealEstateTax()
  }

  // TODO: #must SS and Medicare do per person
  public calculateTotalTaxes(
    year: number,
    timelineRecords: readonly TimelineRecord[]
  ): TotalTaxesCalculationResult {
    const annualTaxesCalculator = new AnnualTaxes(
      year,
      timelineRecords,
      this.taxCalculators,
      this.profile,
      this.realEstateTaxCalculator
    )

    return annualTaxesCalculator.calculate()
  }
}

export default Taxer
